import { CheckCircle2 } from "lucide-react";

export const SubscriptionRequestSuccess = () => (
  <div className="animate-upsell-fade-in-up flex flex-col items-center gap-4 py-6 text-center">
    <div className="flex size-14 items-center justify-center rounded-full bg-[#f4f2ff] text-[#8775f9]">
      <CheckCircle2 size={32} aria-hidden="true" />
    </div>
    <h3 className="text-lg font-light tracking-tight text-[#0a0a0a]">Merci pour votre intérêt !</h3>
    <p className="max-w-sm text-sm text-[#52525b]">
      Un commercial vous recontactera très prochainement pour échanger sur l&apos;évolution de votre pack.
    </p>
  </div>
);
